/**
 * Generated by orval 🍺
 * Do not edit manually.
 * TrainLoop Platform V2 API
 * Model evaluation workbench API
 * OpenAPI spec version: 0.0.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  BatchCreate,
  BatchItemsResponse,
  BatchListResponse,
  BatchResponse,
  HTTPValidationError,
  ListBatchItemsApiBatchesBatchIdItemsGetParams,
  ListBatchesApiBatchesGetParams,
  PipelinesResponse,
} from "../model";

import { orvalFetch } from "../../client.ts";
import type { ErrorType } from "../../client.ts";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K,
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type listPipelinesApiPipelinesGetResponse200 = {
  data: PipelinesResponse;
  status: 200;
};

export type listPipelinesApiPipelinesGetResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type listPipelinesApiPipelinesGetResponseSuccess =
  listPipelinesApiPipelinesGetResponse200 & {
    headers: Headers;
  };
export type listPipelinesApiPipelinesGetResponseError =
  listPipelinesApiPipelinesGetResponse422 & {
    headers: Headers;
  };

export type listPipelinesApiPipelinesGetResponse =
  | listPipelinesApiPipelinesGetResponseSuccess
  | listPipelinesApiPipelinesGetResponseError;

export const getListPipelinesApiPipelinesGetUrl = () => {
  return `/api/pipelines`;
};

/**
 * The pipelines this team may submit batches to, with each one's
 * option schema and stage names.
 * @summary List Pipelines
 */
export const listPipelinesApiPipelinesGet = async (
  options?: Parameters<typeof orvalFetch>[1],
): Promise<listPipelinesApiPipelinesGetResponse> => {
  return orvalFetch<listPipelinesApiPipelinesGetResponse>(
    getListPipelinesApiPipelinesGetUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListPipelinesApiPipelinesGetQueryKey = () => {
  return [`/api/pipelines`] as const;
};

export const getListPipelinesApiPipelinesGetQueryOptions = <
  TData = Awaited<ReturnType<typeof listPipelinesApiPipelinesGet>>,
  TError = ErrorType<HTTPValidationError>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof listPipelinesApiPipelinesGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof orvalFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListPipelinesApiPipelinesGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listPipelinesApiPipelinesGet>>
  > = ({ signal }) =>
    listPipelinesApiPipelinesGet({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listPipelinesApiPipelinesGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListPipelinesApiPipelinesGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listPipelinesApiPipelinesGet>>
>;
export type ListPipelinesApiPipelinesGetQueryError =
  ErrorType<HTTPValidationError>;

export function useListPipelinesApiPipelinesGet<
  TData = Awaited<ReturnType<typeof listPipelinesApiPipelinesGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listPipelinesApiPipelinesGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPipelinesApiPipelinesGet>>,
          TError,
          Awaited<ReturnType<typeof listPipelinesApiPipelinesGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListPipelinesApiPipelinesGet<
  TData = Awaited<ReturnType<typeof listPipelinesApiPipelinesGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listPipelinesApiPipelinesGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPipelinesApiPipelinesGet>>,
          TError,
          Awaited<ReturnType<typeof listPipelinesApiPipelinesGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListPipelinesApiPipelinesGet<
  TData = Awaited<ReturnType<typeof listPipelinesApiPipelinesGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listPipelinesApiPipelinesGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Pipelines
 */

export function useListPipelinesApiPipelinesGet<
  TData = Awaited<ReturnType<typeof listPipelinesApiPipelinesGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listPipelinesApiPipelinesGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListPipelinesApiPipelinesGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type createBatchApiBatchesPostResponse201 = {
  data: BatchResponse;
  status: 201;
};

export type createBatchApiBatchesPostResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type createBatchApiBatchesPostResponseSuccess =
  createBatchApiBatchesPostResponse201 & {
    headers: Headers;
  };
export type createBatchApiBatchesPostResponseError =
  createBatchApiBatchesPostResponse422 & {
    headers: Headers;
  };

export type createBatchApiBatchesPostResponse =
  | createBatchApiBatchesPostResponseSuccess
  | createBatchApiBatchesPostResponseError;

export const getCreateBatchApiBatchesPostUrl = () => {
  return `/api/batches`;
};

/**
 * Submit a batch: every object under ``input_path`` goes through the
 * pipeline and its outputs land under ``output_path``, mirroring the
 * input tree. Read and write access are proven now, so the real AWS
 * error is the response, not a failed batch later.
 *
 * Send ``Idempotency-Key`` (any string up to 128 chars, unique per
 * submission) and a retry from anywhere returns the same batch.
 * @summary Create Batch
 */
export const createBatchApiBatchesPost = async (
  batchCreate: BatchCreate,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<createBatchApiBatchesPostResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<
      string | readonly string[] | undefined
    >(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return orvalFetch<createBatchApiBatchesPostResponse>(
    getCreateBatchApiBatchesPostUrl(),
    {
      ...options,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(options?.headers),
      },
      body: JSON.stringify(batchCreate),
    },
  );
};

export const getCreateBatchApiBatchesPostMutationKey = () =>
  ["createBatchApiBatchesPost"] as const;

export const getCreateBatchApiBatchesPostMutationOptions = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createBatchApiBatchesPost>>,
    TError,
    CreateBatchApiBatchesPostMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof orvalFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createBatchApiBatchesPost>>,
  TError,
  CreateBatchApiBatchesPostMutationVariables,
  TContext
> => {
  const mutationKey = getCreateBatchApiBatchesPostMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createBatchApiBatchesPost>>,
    CreateBatchApiBatchesPostMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return createBatchApiBatchesPost(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateBatchApiBatchesPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof createBatchApiBatchesPost>>
>;
export type CreateBatchApiBatchesPostMutationBody = BatchCreate;
export type CreateBatchApiBatchesPostMutationError =
  ErrorType<HTTPValidationError>;
export type CreateBatchApiBatchesPostMutationVariables = { data: BatchCreate };

/**
 * @summary Create Batch
 */
export const useCreateBatchApiBatchesPost = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createBatchApiBatchesPost>>,
      TError,
      CreateBatchApiBatchesPostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createBatchApiBatchesPost>>,
  TError,
  CreateBatchApiBatchesPostMutationVariables,
  TContext
> => {
  return useMutation(
    getCreateBatchApiBatchesPostMutationOptions(options),
    queryClient,
  );
};
export type listBatchesApiBatchesGetResponse200 = {
  data: BatchListResponse;
  status: 200;
};

export type listBatchesApiBatchesGetResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type listBatchesApiBatchesGetResponseSuccess =
  listBatchesApiBatchesGetResponse200 & {
    headers: Headers;
  };
export type listBatchesApiBatchesGetResponseError =
  listBatchesApiBatchesGetResponse422 & {
    headers: Headers;
  };

export type listBatchesApiBatchesGetResponse =
  | listBatchesApiBatchesGetResponseSuccess
  | listBatchesApiBatchesGetResponseError;

export const getListBatchesApiBatchesGetUrl = (
  params?: ListBatchesApiBatchesGetParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/batches?${stringifiedParams}`
    : `/api/batches`;
};

/**
 * One page of the team's batches, newest first, with the total behind
 * the filters so a client can page through the rest.
 * @summary List Batches
 */
export const listBatchesApiBatchesGet = async (
  params?: ListBatchesApiBatchesGetParams,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<listBatchesApiBatchesGetResponse> => {
  return orvalFetch<listBatchesApiBatchesGetResponse>(
    getListBatchesApiBatchesGetUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListBatchesApiBatchesGetQueryKey = (
  params?: ListBatchesApiBatchesGetParams,
) => {
  return [`/api/batches`, ...(params ? [params] : [])] as const;
};

export const getListBatchesApiBatchesGetQueryOptions = <
  TData = Awaited<ReturnType<typeof listBatchesApiBatchesGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params?: ListBatchesApiBatchesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listBatchesApiBatchesGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListBatchesApiBatchesGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listBatchesApiBatchesGet>>
  > = ({ signal }) =>
    listBatchesApiBatchesGet(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listBatchesApiBatchesGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListBatchesApiBatchesGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listBatchesApiBatchesGet>>
>;
export type ListBatchesApiBatchesGetQueryError = ErrorType<HTTPValidationError>;

export function useListBatchesApiBatchesGet<
  TData = Awaited<ReturnType<typeof listBatchesApiBatchesGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params: undefined | ListBatchesApiBatchesGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listBatchesApiBatchesGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listBatchesApiBatchesGet>>,
          TError,
          Awaited<ReturnType<typeof listBatchesApiBatchesGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListBatchesApiBatchesGet<
  TData = Awaited<ReturnType<typeof listBatchesApiBatchesGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params?: ListBatchesApiBatchesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listBatchesApiBatchesGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listBatchesApiBatchesGet>>,
          TError,
          Awaited<ReturnType<typeof listBatchesApiBatchesGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListBatchesApiBatchesGet<
  TData = Awaited<ReturnType<typeof listBatchesApiBatchesGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params?: ListBatchesApiBatchesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listBatchesApiBatchesGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Batches
 */

export function useListBatchesApiBatchesGet<
  TData = Awaited<ReturnType<typeof listBatchesApiBatchesGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params?: ListBatchesApiBatchesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listBatchesApiBatchesGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListBatchesApiBatchesGetQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type getBatchApiBatchesBatchIdGetResponse200 = {
  data: BatchResponse;
  status: 200;
};

export type getBatchApiBatchesBatchIdGetResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getBatchApiBatchesBatchIdGetResponseSuccess =
  getBatchApiBatchesBatchIdGetResponse200 & {
    headers: Headers;
  };
export type getBatchApiBatchesBatchIdGetResponseError =
  getBatchApiBatchesBatchIdGetResponse422 & {
    headers: Headers;
  };

export type getBatchApiBatchesBatchIdGetResponse =
  | getBatchApiBatchesBatchIdGetResponseSuccess
  | getBatchApiBatchesBatchIdGetResponseError;

export const getGetBatchApiBatchesBatchIdGetUrl = (batchId: string) => {
  return `/api/batches/${batchId}`;
};

/**
 * Status and counts — the polling target.
 * @summary Get Batch
 */
export const getBatchApiBatchesBatchIdGet = async (
  batchId: string,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<getBatchApiBatchesBatchIdGetResponse> => {
  return orvalFetch<getBatchApiBatchesBatchIdGetResponse>(
    getGetBatchApiBatchesBatchIdGetUrl(batchId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetBatchApiBatchesBatchIdGetQueryKey = (batchId: string) => {
  return [`/api/batches/${batchId}`] as const;
};

export const getGetBatchApiBatchesBatchIdGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getBatchApiBatchesBatchIdGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  batchId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBatchApiBatchesBatchIdGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetBatchApiBatchesBatchIdGetQueryKey(batchId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBatchApiBatchesBatchIdGet>>
  > = ({ signal }) =>
    getBatchApiBatchesBatchIdGet(batchId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: batchId !== null && batchId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getBatchApiBatchesBatchIdGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetBatchApiBatchesBatchIdGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBatchApiBatchesBatchIdGet>>
>;
export type GetBatchApiBatchesBatchIdGetQueryError =
  ErrorType<HTTPValidationError>;

export function useGetBatchApiBatchesBatchIdGet<
  TData = Awaited<ReturnType<typeof getBatchApiBatchesBatchIdGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  batchId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBatchApiBatchesBatchIdGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBatchApiBatchesBatchIdGet>>,
          TError,
          Awaited<ReturnType<typeof getBatchApiBatchesBatchIdGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetBatchApiBatchesBatchIdGet<
  TData = Awaited<ReturnType<typeof getBatchApiBatchesBatchIdGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  batchId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBatchApiBatchesBatchIdGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBatchApiBatchesBatchIdGet>>,
          TError,
          Awaited<ReturnType<typeof getBatchApiBatchesBatchIdGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetBatchApiBatchesBatchIdGet<
  TData = Awaited<ReturnType<typeof getBatchApiBatchesBatchIdGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  batchId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBatchApiBatchesBatchIdGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Batch
 */

export function useGetBatchApiBatchesBatchIdGet<
  TData = Awaited<ReturnType<typeof getBatchApiBatchesBatchIdGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  batchId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBatchApiBatchesBatchIdGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetBatchApiBatchesBatchIdGetQueryOptions(
    batchId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type listBatchItemsApiBatchesBatchIdItemsGetResponse200 = {
  data: BatchItemsResponse;
  status: 200;
};

export type listBatchItemsApiBatchesBatchIdItemsGetResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type listBatchItemsApiBatchesBatchIdItemsGetResponseSuccess =
  listBatchItemsApiBatchesBatchIdItemsGetResponse200 & {
    headers: Headers;
  };
export type listBatchItemsApiBatchesBatchIdItemsGetResponseError =
  listBatchItemsApiBatchesBatchIdItemsGetResponse422 & {
    headers: Headers;
  };

export type listBatchItemsApiBatchesBatchIdItemsGetResponse =
  | listBatchItemsApiBatchesBatchIdItemsGetResponseSuccess
  | listBatchItemsApiBatchesBatchIdItemsGetResponseError;

export const getListBatchItemsApiBatchesBatchIdItemsGetUrl = (
  batchId: string,
  params?: ListBatchItemsApiBatchesBatchIdItemsGetParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/batches/${batchId}/items?${stringifiedParams}`
    : `/api/batches/${batchId}/items`;
};

/**
 * Per-object status, stage and error — the error manifest for a
 * ``completed_with_errors`` batch. Filter ``status=failed`` to list only
 * what needs attention.
 * @summary List Batch Items
 */
export const listBatchItemsApiBatchesBatchIdItemsGet = async (
  batchId: string,
  params?: ListBatchItemsApiBatchesBatchIdItemsGetParams,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<listBatchItemsApiBatchesBatchIdItemsGetResponse> => {
  return orvalFetch<listBatchItemsApiBatchesBatchIdItemsGetResponse>(
    getListBatchItemsApiBatchesBatchIdItemsGetUrl(batchId, params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListBatchItemsApiBatchesBatchIdItemsGetQueryKey = (
  batchId: string,
  params?: ListBatchItemsApiBatchesBatchIdItemsGetParams,
) => {
  return [
    `/api/batches/${batchId}/items`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListBatchItemsApiBatchesBatchIdItemsGetQueryOptions = <
  TData = Awaited<ReturnType<typeof listBatchItemsApiBatchesBatchIdItemsGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  batchId: string,
  params?: ListBatchItemsApiBatchesBatchIdItemsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listBatchItemsApiBatchesBatchIdItemsGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListBatchItemsApiBatchesBatchIdItemsGetQueryKey(batchId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listBatchItemsApiBatchesBatchIdItemsGet>>
  > = ({ signal }) =>
    listBatchItemsApiBatchesBatchIdItemsGet(batchId, params, {
      signal,
      ...requestOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: batchId !== null && batchId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listBatchItemsApiBatchesBatchIdItemsGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListBatchItemsApiBatchesBatchIdItemsGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listBatchItemsApiBatchesBatchIdItemsGet>>
>;
export type ListBatchItemsApiBatchesBatchIdItemsGetQueryError =
  ErrorType<HTTPValidationError>;

export function useListBatchItemsApiBatchesBatchIdItemsGet<
  TData = Awaited<ReturnType<typeof listBatchItemsApiBatchesBatchIdItemsGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  batchId: string,
  params: undefined | ListBatchItemsApiBatchesBatchIdItemsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listBatchItemsApiBatchesBatchIdItemsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listBatchItemsApiBatchesBatchIdItemsGet>>,
          TError,
          Awaited<ReturnType<typeof listBatchItemsApiBatchesBatchIdItemsGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListBatchItemsApiBatchesBatchIdItemsGet<
  TData = Awaited<ReturnType<typeof listBatchItemsApiBatchesBatchIdItemsGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  batchId: string,
  params?: ListBatchItemsApiBatchesBatchIdItemsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listBatchItemsApiBatchesBatchIdItemsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listBatchItemsApiBatchesBatchIdItemsGet>>,
          TError,
          Awaited<ReturnType<typeof listBatchItemsApiBatchesBatchIdItemsGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListBatchItemsApiBatchesBatchIdItemsGet<
  TData = Awaited<ReturnType<typeof listBatchItemsApiBatchesBatchIdItemsGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  batchId: string,
  params?: ListBatchItemsApiBatchesBatchIdItemsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listBatchItemsApiBatchesBatchIdItemsGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Batch Items
 */

export function useListBatchItemsApiBatchesBatchIdItemsGet<
  TData = Awaited<ReturnType<typeof listBatchItemsApiBatchesBatchIdItemsGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  batchId: string,
  params?: ListBatchItemsApiBatchesBatchIdItemsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listBatchItemsApiBatchesBatchIdItemsGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListBatchItemsApiBatchesBatchIdItemsGetQueryOptions(
    batchId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type cancelBatchApiBatchesBatchIdCancelPostResponse200 = {
  data: BatchResponse;
  status: 200;
};

export type cancelBatchApiBatchesBatchIdCancelPostResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type cancelBatchApiBatchesBatchIdCancelPostResponseSuccess =
  cancelBatchApiBatchesBatchIdCancelPostResponse200 & {
    headers: Headers;
  };
export type cancelBatchApiBatchesBatchIdCancelPostResponseError =
  cancelBatchApiBatchesBatchIdCancelPostResponse422 & {
    headers: Headers;
  };

export type cancelBatchApiBatchesBatchIdCancelPostResponse =
  | cancelBatchApiBatchesBatchIdCancelPostResponseSuccess
  | cancelBatchApiBatchesBatchIdCancelPostResponseError;

export const getCancelBatchApiBatchesBatchIdCancelPostUrl = (
  batchId: string,
) => {
  return `/api/batches/${batchId}/cancel`;
};

/**
 * Stop a batch. In-flight items finish; nothing new starts. Outputs
 * already delivered stay delivered.
 * @summary Cancel Batch
 */
export const cancelBatchApiBatchesBatchIdCancelPost = async (
  batchId: string,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<cancelBatchApiBatchesBatchIdCancelPostResponse> => {
  return orvalFetch<cancelBatchApiBatchesBatchIdCancelPostResponse>(
    getCancelBatchApiBatchesBatchIdCancelPostUrl(batchId),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getCancelBatchApiBatchesBatchIdCancelPostMutationKey = () =>
  ["cancelBatchApiBatchesBatchIdCancelPost"] as const;

export const getCancelBatchApiBatchesBatchIdCancelPostMutationOptions = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelBatchApiBatchesBatchIdCancelPost>>,
    TError,
    CancelBatchApiBatchesBatchIdCancelPostMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof orvalFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof cancelBatchApiBatchesBatchIdCancelPost>>,
  TError,
  CancelBatchApiBatchesBatchIdCancelPostMutationVariables,
  TContext
> => {
  const mutationKey = getCancelBatchApiBatchesBatchIdCancelPostMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof cancelBatchApiBatchesBatchIdCancelPost>>,
    CancelBatchApiBatchesBatchIdCancelPostMutationVariables
  > = (props) => {
    const { batchId } = props ?? {};

    return cancelBatchApiBatchesBatchIdCancelPost(batchId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CancelBatchApiBatchesBatchIdCancelPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof cancelBatchApiBatchesBatchIdCancelPost>>
>;

export type CancelBatchApiBatchesBatchIdCancelPostMutationError =
  ErrorType<HTTPValidationError>;
export type CancelBatchApiBatchesBatchIdCancelPostMutationVariables = {
  batchId: string;
};

/**
 * @summary Cancel Batch
 */
export const useCancelBatchApiBatchesBatchIdCancelPost = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof cancelBatchApiBatchesBatchIdCancelPost>>,
      TError,
      CancelBatchApiBatchesBatchIdCancelPostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof cancelBatchApiBatchesBatchIdCancelPost>>,
  TError,
  CancelBatchApiBatchesBatchIdCancelPostMutationVariables,
  TContext
> => {
  return useMutation(
    getCancelBatchApiBatchesBatchIdCancelPostMutationOptions(options),
    queryClient,
  );
};
